export default __webpack_public_path__ + "static/hinge-7cf4cd72577ff9d5ba6eb85f5666e4be.png";